'use strict';

var baseclientSideValidation = require('base/components/clientSideValidation');
var debounce = require('lodash/debounce');

function validatePattern(element) {
	let fieldValue = element.val();
	let invalidFeedback = element.siblings('.invalid-feedback');
	if(fieldValue) {
		let fieldInvalidError = element.data('invalid-error');
		let fieldPattern = element.hasClass('gift-message-text') ? element.siblings('.gift-message-pattern').val() : (element.prop('pattern') || element.attr('pattern'));
		let isValidPAttern = new RegExp(fieldPattern).test(fieldValue);
		if(!isValidPAttern) {
			element.addClass('is-invalid');
			invalidFeedback.empty().html(fieldInvalidError);
		}else {
			element.removeClass('is-invalid');
			invalidFeedback.empty();
		}
	}else {
		element.removeClass('is-invalid');
		invalidFeedback.empty();
	}
}

module.exports = $.extend({}, baseclientSideValidation, {
	invalid: function invalid() {
		$('form input, form select').on('invalid', function (e) {
			e.preventDefault();
			this.setCustomValidity('');
			if (!this.validity.valid) {
				var validationMessage = 'Please fill in this required field.';
				$(this).addClass('is-invalid');
				$(this).closest('form').find('.server-error-msg-wrapper').find('.msgcss-change').text('');

				if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
					validationMessage = $(this).data('pattern-mismatch');
				}
				if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
					validationMessage = $(this).data('range-error');
				}
				if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
					validationMessage = $(this).data('range-error');
				}
				if (this.validity.valueMissing && $(this).data('missing-error')) {
					validationMessage = $(this).data('missing-error');
				}
				if (this.validity.typeMismatch && $(this).data('type-mismatch')) {
					validationMessage = $(this).data('type-mismatch');
				}
				$(this).parents('.form-group').find('.invalid-feedback')
					.text(validationMessage);
			}
		});
	},
	handle_phone_nuber_formate(){
		$('.custom-phone-format').each(function(){
			var phoneHiddenField = $(this).clone();
			$(this).after(phoneHiddenField);
			$(phoneHiddenField).attr('type', 'hidden')
				.attr('class', 'custom-phone-format-hidden')
				.removeAttr('id')
				.removeAttr('data-missing-error')
				.removeAttr('data-pattern-mismatch')
				.addClass('form-control');
				
			$(this).attr('name', '');
		});
		$('.custom-phone-format').keyup(function(event){
			let phoneValueKeyUp = $(this).val().replace(/[^\d]/g, '');
			if(phoneValueKeyUp.length === 10) {
				event.currentTarget.value = phoneValueKeyUp.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
			}
			$(this).closest('.form-group').find('.custom-phone-format-hidden').val($(this).val().replace(/[^\d]/g, ''));
		}).on('blur', function(event) {
			let phoneValueBlur = $(this).val().replace(/[^\d]/g, '');
			event.currentTarget.value = phoneValueBlur.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
			$(this).closest('.form-group').find('.custom-phone-format-hidden').val($(this).val().replace(/[^\d]/g, ''));
			var invalidMsz = $('.custom-phone-format').attr('data-pattern-mismatch');

			//shipping addres
			if($(this).closest('.shippingPhoneNumber').find('.custom-phone-format-hidden')){
				let hiddenPhoneVal = $(this).val();
				if(hiddenPhoneVal.length == 0){
					if($(this).parents().find('#defaultTelephoneNumber').hasClass('d-block')){
						$(this).parents().find('#defaultTelephoneNumber').removeClass('d-block');
					}
				}
				else if(hiddenPhoneVal.length < 10) {
					$(this).parents().find('#defaultTelephoneNumber').addClass('d-block').text(invalidMsz);
				}
				else{
					$(this).parents().find('#defaultTelephoneNumber').removeClass('d-block');
				}
			}

			//Billing Phone Number

			if($(this).closest('#billingPhoneNumber').find('.custom-phone-format-hidden')){
				let hiddenPhoneVal = $(this).val();
				if(hiddenPhoneVal.length == 0){
					if($(this).parents().find('#phoneInvalidMessage').hasClass('d-block')){
						$(this).parents().find('#phoneInvalidMessage').removeClass('d-block');
					}
				}
				else if(hiddenPhoneVal.length < 10) {
					$(this).parents().find('#phoneInvalidMessage').addClass('d-block').text(invalidMsz);
				}
				else{
					$(this).parents().find('#phoneInvalidMessage').removeClass('d-block');
				}
			}
		});
	},

	//form validation
	handle_address_formate(){
		$('.custom-addr-val').each(function(){
			// eslint-disable-next-line
			$(this).attr('pattern', '^([a-zA-Z0-9&amp;,@#$%()_|\\/\\\\\\\\\\-:. ]+)*$');
		});
	},

	//email lowercase format change
	handle_email_format(){
		$('.custom-email-format').keyup(debounce(function(event){
			let emailValueKeyUp = $(this).val();
			event.currentTarget.value = emailValueKeyUp.toLowerCase();
		}, 300)).on('blur', function(event) {
			let emailValueBlur = $(this).val();
			event.currentTarget.value = emailValueBlur.toLowerCase();
		});
	},

	//pattern ontime validation
	handle_pattern_ontime_validation(){
		$('.custom-pattern-check').keyup(debounce(function(){
			validatePattern($(this));
		}, 300)).on('blur', function() {
			validatePattern($(this));
		});
	}
});
